var exports = {
  "k": "x2b2fbebb--69d894--container",
};

module.exports = exports;
